import React, { useEffect, useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SetMultipleDocument, { UploadedDocument } from '../../../../SetMultipleDocument';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList';
import { Spin } from 'antd';


let searchDocument: Params = { CodeAgence: 'MOURABAHA', Table: "vw_DocumentsParEtape", Colonne1: "CodeEtape", Colonne2: "", Colagence: 'CodeProcessus', Init: 'VALIDATION', Choix: 34 }


function Tab5(props: { form?: any, documents: UploadedDocument[], loading : boolean }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  return (
    <div className='tabItem'>
      <div>
        <Box padding={2} fontStyle="inherit" className='border' width={"85%"} position={"absolute"} height={"400px"} overflow={"auto"}>
          {/* LISTE DES DOCUMENTS DE LA PROPOSITION DE FINANCEMENT */}
          <legend >Documents attachés à la proposition</legend>
          <Spin spinning={props.loading} size="large" style={{ color: 'green' }}>
            <ReadOnlyDocumentList documents={props.documents} loading={props.loading} />
          </Spin>

          <legend>Ajouter des documents</legend>
          <br />
          <Grid item xs={12} md={12} lg={12} >
            <SetMultipleDocument form={props.form} Size="large" width={4} label="Documents" name="Document" Parametre={searchDocument} />
          </Grid>
        </Box>
      </div>
    </div>
  )
}

export default Tab5;  
